import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as SettingsIcon } from 'src/assets/tailwind/Notifications/settings-icon.svg';
import { Button } from 'src/components/ui/button';
import { Typography } from 'src/components/ui/typography';
import useUpdateAccessRights from 'src/hooks/useUpdateAccessRights';
import { ADMIN_CONSOLE_NOTIFICATIONS_ROUTE, NOTIFICATION_RETENTION_DAYS, SETTINGS_NOTIFICATIONS_ROUTE } from '../../constants';
import { TRANSLATION_CONSTANTS as T } from 'src/utils/translations';

type NotificationPanelFooterProps = {
  onClose?: () => void;
};

const NotificationPanelFooter = ({ onClose }: NotificationPanelFooterProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { isSysAdminUser } = useUpdateAccessRights();

  return (
    <div className="tw:flex tw:flex-wrap tw:items-center tw:justify-between tw:gap-s tw:border-t tw:border-solid tw:border-border-secondary tw:px-m tw:py-s">
      <Typography variant="b2" colorClass="tw:text-text-disabled tw:flex-1 tw:min-w-0">
        {t(T.retentionDays, { NOTIFICATION_RETENTION_DAYS })}
      </Typography>
      <Button
        hierarchy="link"
        size="medium"
        text={t(T.notifications) + ' ' + t(T.settings)}
        leftIcon={SettingsIcon}
        onClick={() => {
          onClose?.();
          navigate(isSysAdminUser ? ADMIN_CONSOLE_NOTIFICATIONS_ROUTE : SETTINGS_NOTIFICATIONS_ROUTE);
        }}
      />
    </div>
  );
};

export default NotificationPanelFooter;
